import { EditType, LooseAutocomplete } from 'types';
import { SearchWorkerResult } from 'components/searchBox/types';
import {
  EditableFormSubmissionWorker,
  EditableEnhancedFormSubmissionWorker,
  OnFormSubmissionWorkerConfirmed,
} from 'containers/jobsiteFormSubmission/types';

export type OnWorkerConfirmed =
  OnFormSubmissionWorkerConfirmed<EditableEnhancedFormSubmissionWorker>;

export type JobsiteFormSubmissionWorkerEdit =
  EditableEnhancedFormSubmissionWorker & {
    editType: EditType;
    searchWorkerResult: SearchWorkerResult;
  };

export type FormSubmissionVisitorsProps = {
  jobsiteFormSubmissionId?: string;
  associationType?: LooseAutocomplete<'visit'>;
  value?: EditableFormSubmissionWorker[];
  onChange?: (value: EditableFormSubmissionWorker[]) => void;
  allowAdd?: boolean;
  allowEdit?: boolean;
  allowDelete?: boolean;
};

export enum ParticipantType {
  Injured = 'Injured',
  Other = 'Other',
  Responsible = 'Responsible',
  Suspected = 'Suspected',
  Witness = 'Witness',
}
